"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckingAccountCard = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _body = require("./body.js");

var _offerStyles = require("../common/offer-styles.js");

var _tagline = require("./tagline.js");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["className", "offer"];

var Container = _styledComponents["default"].div.withConfig({
  displayName: "Container",
  componentId: "sc-5pxiyp-0"
})([""]);

var CardWithoutPadding = (0, _styledComponents["default"])(_offerStyles.Card).withConfig({
  displayName: "CardWithoutPadding",
  componentId: "sc-5pxiyp-1"
})(["&&{padding:0;}"]);
var CheckingAccountCard = (0, _styledComponents["default"])(function (_ref) {
  var className = _ref.className,
      offer = _ref.offer,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Container, {
    className: className,
    children: [(offer === null || offer === void 0 ? void 0 : offer.tagline) != null && /*#__PURE__*/(0, _jsxRuntime.jsx)(_tagline.Tagline, {
      children: offer.tagline
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(CardWithoutPadding, {
      "data-testid": "checking-account-card:index:wrapper",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_body.BCACardBody, Object.assign({
        offer: offer
      }, rest))
    })]
  });
}).withConfig({
  displayName: "CheckingAccountCard",
  componentId: "sc-5pxiyp-2"
})([""]);
exports.CheckingAccountCard = CheckingAccountCard;
CheckingAccountCard.displayName = 'CheckingAccountCard';
CheckingAccountCard.Body = _body.BCACardBody;
//# sourceMappingURL=index.js.map